import cx from 'classnames';
import {useField} from 'formik';
import {isBoolean} from 'lodash';
import {useCallback, useMemo} from 'react';

import {FormControl, FormControlProps} from '../FormControl';
import {PhoneInput} from '../PhoneInput';

type Props = {
    name: string;
    label?: string;
    styled?: boolean;
} & Partial<FormControlProps>;

export const PhoneInputFormik: React.FC<Props> = ({
    name,
    className,
    label,
    required,
    disabled,
    skipErrorMessage,
    hasError: hasErrorProp,
    styled = true
}: Props) => {
    const [field, meta, helpers] = useField(name);

    const hasError = useMemo<boolean>(
        () => {
            if (isBoolean(hasErrorProp)) {
                return hasErrorProp;
            }

            return meta.error && (meta.touched || meta.value) || meta.touched && required && !meta.value;
        },
        [meta, hasErrorProp, required]
    );

    const isDirty = useMemo<boolean>(() => meta.value !== meta.initialValue, [meta]);

    const handleBlur = useCallback((e: React.FocusEvent) => {
        field.onBlur(e);
    }, [field]);

    const handleChange = useCallback((phoneNumber: string) => {
        helpers.setValue(phoneNumber);
    }, [helpers]);

    // TODO: move FormControl inside PhoneInput
    return (
        <FormControl {...{
            name, value: field.value, className: cx(className, 'vs-form-control-phone'), required, label,
            disabled, skipErrorMessage, styled, hasError, isDirty, errorMessage: meta.error, onBlur: handleBlur
        }}
        >
            {({onFocus, onBlur}) => (
                <PhoneInput
                    styled={styled}
                    inputProps={{name: field.name}}
                    value={field.value === null ? '' : field.value}
                    disabled={disabled}
                    onChange={handleChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            )}
        </FormControl>
    );
};
